import { SET_DEFERRED_SERVICES } from './actionTypes';

export const setDeferredServices = deferredServices => {
  return {
    type: SET_DEFERRED_SERVICES,
    payload: deferredServices
  };
};



// WEBPACK FOOTER //
// ./src/store/reducers/deferred/actions.js